import React from "react";
import { ConnectImage } from "../../../shared-components";
import { Button, ButtonSize, ButtonVariant } from "@wattpad/web-ui-library";
import { useTrans } from "../../../hooks";
import PropTypes from "prop-types";

// TOOD: isolate the facebook login button styles from the login, signup and other CSS modules.
// Do the same for the other buttons/interactions. Then figure out common styles and share them.
const ButtonLabel = ({ action }) => {
  const { trans } = useTrans();
  return (
    <>
      <ConnectImage
        name="/shared/facebook-login-color.png"
        title="Facebook Login"
        width="18"
        className="google-login-icon"
        aria-hidden="true"
      />
      <span>
        <span className="auth-button-text-new">
          {action === "login"
            ? trans("Log in with Facebook")
            : trans("Sign up with Facebook")}
        </span>
      </span>
    </>
  );
};

export const FacebookSSOButton = ({ action }) => {
  return (
    <Button
      className="btn-facebook"
      variant={ButtonVariant.SECONDARY}
      size={ButtonSize.MEDIUM}
      fullWidth
      label={<ButtonLabel action={action} />}
      data-source={action}
    />
  );
};

FacebookSSOButton.propTypes = {
  nextUrl: PropTypes.string,
  action: PropTypes.oneOf(["login", "signup"])
};

ButtonLabel.propTypes = {
  action: PropTypes.oneOf(["login", "signup"])
};
